
import AreaChart from "@/components/chart/AreaChart";
import PortfolioKpi from "@/components/portfolio/PortfolioKpi";

export default {
    name: "MarketAnalysisPortfolioInfo",

    components: {
        PortfolioKpi,
        AreaChart,
    },

    data() {
        return {
            interval: this.$store.state.preferences.activeChartInterval,
            chartType: this.$store.state.preferences.chartTypePortfolioSelected,
        }
    },

    computed: {
        intervals() {
            return [
                {
                    interval: 'day',
                    text: this.$t('common.intervals.day')
                },
                {
                    interval: 'week',
                    text: this.$t('common.intervals.week')
                },
                {
                    interval: 'month',
                    text: this.$t('common.intervals.month')
                },
                {
                    interval: '3m',
                    text: this.$t('common.intervals.threeMonths')
                },
                {
                    interval: '6m',
                    text: this.$t('common.intervals.sixMonths')
                },
                {
                    interval: 'ytd',
                    text: this.$t('common.intervals.ytd')
                },
                {
                    interval: 'year',
                    text: this.$t('common.intervals.year')
                },
                {
                    interval: '2y',
                    text: this.$t('common.intervals.twoYears')
                },
                {
                    interval: '3y',
                    text: this.$t('common.intervals.threeYears')
                },
                {
                    interval: '4y',
                    text: this.$t('common.intervals.fourYears')
                },
                {
                    interval: 'fiveyears',
                    text: this.$t('common.intervals.fiveYears')
                },
                {
                    interval: '10y',
                    text: this.$t('common.intervals.tenYears')
                },
                {
                    interval: '20y',
                    text: this.$t('common.intervals.twentyYears')
                },
                {
                    interval: 'max',
                    text: this.$t('common.intervals.max')
                }
            ]
        },
        accountCurrency() {
            return this.$store.state.account.currency;
        },
    },
}
